import React from 'react'
import { Modal, Box } from '@mui/material'
import GroupChat from './GroupChat'

const GroupChatModal = (props) => {
    return (
        <div>
            <Modal open={props.modalOpen} onClose={props.handleModalClose} onHide={props.handleModalClose}>
                <Box sx={{ overflowY: 'auto', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'white', padding: '2rem', borderRadius: "40px", display: 'flex', flexDirection: "column", maxHeight: "1000px", maxWidth: "850px" }}>
                    <GroupChat process_id={props.process_id} path="OtherSource"/>
                </Box>
            </Modal>
        </div>
    )
}

export default GroupChatModal
